export const VERSION = '0.1.2';
